(function($){
    $(document).ready(function() {
        var int = setInterval(function(){
            if($('[name="phone-2"]').length > 0){
                $('[name="phone-2"]').inputmask("999-999-999");
                clearInterval(int);
            }
        })
        var int2 = setInterval(function(){
            if($('[name="phone-1"]').length > 0){
                $('[name="phone-1"]').inputmask("99/999-99-99");
                clearInterval(int2);
            }
        })
        var int3 = setInterval(function(){
            if($('[data-form-id="5128"] [name="text-3"]').length > 0){
                $('[data-form-id="5128"] [name="text-3"]').inputmask("99-999");
                clearInterval(int3);
            }
        })
    });
})(jQuery)